// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"7708d646","703":"c9510de9","787":"486652fa"}[chunkId] + ".chunk.js";
};